export const mdl07Urls = {
  tasksURL: 'mdl07/dashBoard/summaryTaskType',
  fetchTasksURL: 'mdl07/dashBoard/summaryTask',
}
